import React, { useRef } from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { CATEGORY_COLOR, TEXT_COLOR } from "../../utils/constant";
import { set_filters } from "../../store/actions/action";

function MenuCategories(props) {
  const paragraphRefs = useRef([]);
  const scrollContainerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const {
    reducer,
    allitem,
    filterItems,
    selectedCategory,
    allCategoryList,
    labelList,
    setOpen,
  } = props;
  const appliedfilters = props.filterReducer;
  
  const storeInfo = props.sessionReducer?.store_details;
  const storeInfoConfig = props.sessionReducer?.store_config;

  let primaryColor =  storeInfoConfig?.general_config?.primary_color;
  let secondaryColor =  storeInfoConfig?.general_config?.secondary_color;

  const handleCategoryClick = (obj, type, index) => {
    filterItems(obj, type);
    props.set_filters({ ...appliedfilters, category: { type, obj } });

    if (paragraphRefs.current[index]) {
      paragraphRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start", // Align to the left of the scroll container
      });
    }
  };

  let selectCategory = selectedCategory ? selectedCategory : "All_Item";

  let categorySeq = allCategoryList.sort((a, b) => {
    const catA = a.cat_sequence_no || 0;
    const catB = b.cat_sequence_no || 0;
    return catA - catB;
  });

  const getCategoryStyle = (index) => ({
    margin: "0.4rem",
    padding: "0.5rem",
    display: "flex",
    boxShadow:
      selectCategory === index
        ? "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
        : "none",
    backgroundColor:
      selectCategory === index
        ? primaryColor || CATEGORY_COLOR
        : "transparent",
    borderRadius: "1rem",
    cursor: "pointer",
    whiteSpace: "nowrap",
  });

  const selectedStyle = (index) => ({
    fontWeight: "500",
    padding: selectCategory === index ? "0rem 0.5rem" : "",
    color:
      selectCategory === index
        ? secondaryColor|| TEXT_COLOR
        : "inherit",
  });

  return (
    <div>
      {/* <Grid
        ref={scrollContainerRef}
        style={{
          overflowX: "auto",
          display: "flex",
          width: "100%",
          scrollbarWidth: "none",
        }}
      >
        <div
          ref={(el) => (paragraphRefs.current[0] = el)}
          style={getCategoryStyle("All_Item")}
          onClick={() =>
            handleCategoryClick({ category_id: "All_Item" }, "", 0)
          }
        >
          <Typography style={{ display: "flex", width: "max-content" }}>
            <span style={selectedStyle("All_Item")}>All Items</span>
          </Typography>
        </div>

        {labelList?.map((ele, i) =>
          allitem.filter((e) => e?.tag[0] === ele.name).length > 0 ? (
            <div
              key={ele.name}
              ref={(el) => (paragraphRefs.current[i + 1] = el)}
              style={getCategoryStyle(ele.name)}
              onClick={() => handleCategoryClick(ele, "label", i + 1)}
            >
              <Typography style={{ display: "flex", width: "max-content" }}>
                <span style={selectedStyle(ele.name)}>{ele.name}</span>
              </Typography>
            </div>
          ) : null
        )}

        {categorySeq?.map((obj, index) => {
          const refIndex = labelList.length + index + 1;
          return (
            <div
              key={obj.category_id}
              ref={(el) => (paragraphRefs.current[refIndex] = el)}
              style={getCategoryStyle(obj.category_id)}
              onClick={() => handleCategoryClick(obj, "category", refIndex)}
            >
              <Typography
                style={{
                  display: "flex",
                  width: "max-content",
                  textTransform: "capitalize",
                }}
              >
                <span style={selectedStyle(obj.category_id)}>
                  {obj.category_name.toLowerCase()}
                </span>
              </Typography>
            </div>
          );
        })}
      </Grid> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  reducer: state.customerReducer,
    filterReducer: state.filterReducer,
});

const mapDispatchToProps = (dispatch) => ({
  set_filters: (obj) => dispatch(set_filters(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuCategories);
